/* Modulo Featured Products — collection carousel with touch swipe and arrows.
   Vanilla, lazy-init, reduced-motion aware. */
(function () {
  'use strict';

  /* ── Cart notify ────────────────────────────────────────────────────
     Per Shopify's docs a theme's cart is recognised one of two ways:
     Dawn-style, via an element whose prototype has getSectionsToRender(),
     or Horizon-style, via a cart-icon with renderCartBubble() and
     cart-items with updateQuantity() — which are driven by a `cart:update`
     event dispatched on `document`. This section never sent that event, so
     on Horizon and its forks the badge kept its render-time number until
     the shopper reloaded.

     itemCount comes from /cart.js, NOT from summing the add response.
     /cart/add.js returns only "the line items associated with the added
     items" and carries no item_count, so summing it reports how many were
     just added — a shopper holding 3 who adds 1 would have the badge
     REWRITTEN to 1. A null count still tells a component to re-render.

     NOTE: this section does not yet request the theme's cart sections on
     add, so on a DAWN-style theme the drawer it opens can still show
     page-load HTML. Wiring `sections`/`sections_url` here the way
     product-quickbuy does is tracked as follow-up work. */
  function notifyCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (window.Shopify && window.Shopify.PubSub) {
      try { window.Shopify.PubSub.publish('cart-update', {}); } catch (e) {}
    }
    function fire(count) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: count, source: 'modulo-featured-products' } }
        }));
      } catch (e) {}
    }
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (x) { return x.ok ? x.json() : null; })
      .then(function (c) { fire(c && typeof c.item_count === 'number' ? c.item_count : null); })
      .catch(function () { fire(null); });
  }


  if (typeof window === 'undefined') return;

  var SWIPE_THRESHOLD = 40;

  function getCardsPerView(track) {
    var styles = window.getComputedStyle(track);
    var cpv = parseFloat(styles.getPropertyValue('--modulo-fp-cpv')) || 4;
    var cpvm = parseFloat(styles.getPropertyValue('--modulo-fp-cpv-m')) || 1.3;
    return window.innerWidth <= 860 ? cpvm : cpv;
  }

  function getGap(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.gap) || 0;
  }

  function maxIndex(total, cpv) {
    return Math.max(0, Math.ceil(total - cpv));
  }

  /* ─── Wishlist (localStorage, no backend) ─── */
  function wishlistRead(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function wishlistWrite(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  function wishlistKey(root) {
    return root.getAttribute('data-modulo-fp-wishlist-key') || 'modulo_wishlist';
  }

  function wishlistHydrate(root) {
    var key = wishlistKey(root);
    var saved = wishlistRead(key);
    if (!saved.length) return;
    var buttons = root.querySelectorAll('[data-modulo-fp-wishlist]');
    for (var i = 0; i < buttons.length; i++) {
      var h = buttons[i].getAttribute('data-product-handle');
      if (saved.indexOf(h) !== -1) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      }
    }
  }

  function wishlistToggle(btn, root) {
    var key = wishlistKey(root);
    var h = btn.getAttribute('data-product-handle');
    var list = wishlistRead(key);
    var idx = list.indexOf(h);
    if (idx === -1) {
      list.push(h);
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    }
    wishlistWrite(key, list);
    // Sync other buttons for the same product across all sliders on the page
    document.dispatchEvent(new CustomEvent('modulo:wishlist:changed', {
      detail: { handle: h, active: idx === -1, key: key }
    }));
  }

  // Cross-section sync: when one section toggles, update matching handles elsewhere
  document.addEventListener('modulo:wishlist:changed', function (e) {
    var d = e.detail;
    var selector = '[data-modulo-fp-wishlist][data-product-handle="' + d.handle + '"]';
    var buttons = document.querySelectorAll(selector);
    for (var i = 0; i < buttons.length; i++) {
      var section = buttons[i].closest('[data-modulo-fp-wishlist-key]');
      if (!section || section.getAttribute('data-modulo-fp-wishlist-key') !== d.key) continue;
      if (d.active) {
        buttons[i].classList.add('is-active');
        buttons[i].setAttribute('aria-pressed', 'true');
      } else {
        buttons[i].classList.remove('is-active');
        buttons[i].setAttribute('aria-pressed', 'false');
      }
    }
  });

  /* ─── Minimal cart-add helpers (duplicated from extensions/modulo-theme/assets/modulo-block-add-to-cart.js) ─── */
  function findCartDrawer() {
    return document.querySelector(
      'cart-drawer, cart-drawer-component, [is="cart-drawer"], [data-cart-drawer]'
    );
  }

  function openCartDrawer() {
    var drawer = findCartDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.show === 'function') drawer.show();
    else {
      var trigger = document.querySelector('[aria-controls*="cart"]');
      if (trigger) trigger.click();
    }
  }

  function quickAdd(button) {
    if (button.dataset.adding === '1') return;
    button.dataset.adding = '1';
    var variantId = button.getAttribute('data-variant-id');
    var labelEl = button.querySelector('.modulo-featured-products__quick-add-label');
    var originalLabel = labelEl ? labelEl.textContent : '';
    var addedLabel = button.getAttribute('data-added-label') || 'Added';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      // X-Modulo-Internal opts out of the bundle block's in-flight fetch shim.
      // Without it a quick-add landing inside that window is answered with a
      // synthetic 200 {"items":[]} and takes the SUCCESS path on an add that
      // never happened.
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Modulo-Internal': 'featured-products' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-add-failed');
      return r.json();
    }).then(function () {
      if (labelEl) {
        labelEl.textContent = addedLabel;
        setTimeout(function () { labelEl.textContent = originalLabel; }, 1800);
      }
      notifyCart();
      openCartDrawer();
    }).catch(function () {
      if (labelEl) {
        labelEl.textContent = 'Error';
        setTimeout(function () { labelEl.textContent = originalLabel; }, 1800);
      }
    }).finally(function () {
      button.dataset.adding = '0';
    });
  }

  function initSlider(slider) {
    var root = slider.closest('.modulo-featured-products') || slider;
    if (root.classList.contains('modulo-featured-products--stack')) return;

    var track = slider.querySelector('.modulo-featured-products__track');
    if (!track) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll('.modulo-featured-products__card')
    );
    if (!cards.length) return;

    var prevBtn = slider.querySelector('[data-modulo-featured-products-prev]');
    var nextBtn = slider.querySelector('[data-modulo-featured-products-next]');

    var index = 0;
    var cpv = getCardsPerView(track);
    var max = maxIndex(cards.length, cpv);

    function cardStep() {
      var first = cards[0];
      if (!first) return 0;
      return first.getBoundingClientRect().width + getGap(track);
    }

    function update() {
      var offset = -1 * cardStep() * index;
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= max;
    }

    function goTo(i) {
      index = Math.max(0, Math.min(max, i));
      update();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    /* ─── Pointer / touch swipe ─── */
    var pointerStartX = 0;
    var pointerDelta = 0;
    var dragging = false;
    var dragMoved = false;

    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      dragMoved = false;
      pointerStartX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      pointerDelta = 0;
      track.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var x = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      pointerDelta = x - pointerStartX;
      if (Math.abs(pointerDelta) > 5) dragMoved = true;
      var offset = -1 * cardStep() * index + pointerDelta;
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (Math.abs(pointerDelta) > SWIPE_THRESHOLD) {
        if (pointerDelta < 0) next();
        else prev();
      } else {
        update();
      }
      pointerDelta = 0;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', function () {
      if (dragging) onPointerUp();
    });

    /* Suppress link-click when user was dragging */
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    /* ─── Wire arrows ─── */
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    /* ─── Wire quick-add + wishlist (event delegation) ─── */
    slider.addEventListener('click', function (e) {
      var qaBtn = e.target.closest('[data-modulo-fp-quick-add]');
      if (qaBtn && !qaBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(qaBtn);
        return;
      }
      var wlBtn = e.target.closest('[data-modulo-fp-wishlist]');
      if (wlBtn) {
        e.preventDefault();
        e.stopPropagation();
        wishlistToggle(wlBtn, root);
        return;
      }
    });

    /* ─── Hydrate wishlist state on init ─── */
    wishlistHydrate(root);

    /* ─── Resize handling ─── */
    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        cpv = getCardsPerView(track);
        max = maxIndex(cards.length, cpv);
        if (index > max) index = max;
        update();
      }, 100);
    }
    window.addEventListener('resize', onResize);

    /* ─── Init ─── */
    update();
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-featured-products]', initSlider);
    } else {
      var sliders = document.querySelectorAll('[data-modulo-featured-products]');
      for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
